import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
export default class FormattedMoney extends Component {
  view() {
    const moneyName = app.forum.attribute('antoinefr-money.moneyname') || '[money]';
    return m('span', moneyName.replace('[money]', this.attrs.money + ''));
  }
}
flarum.reg.add('clarkwinkelmann-money-rewards', 'forum/components/FormattedMoney', FormattedMoney);